import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject, Injector } from '@angular/core';
import { throwError } from 'rxjs';
import { SignInService } from 'libs/shared/web/auth/sign-in/sign.in.service';

// SignInService injects HttpClient; resolve lazily via Injector to avoid circular DI.
export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(Injector).get(SignInService);

  if (!window.navigator.onLine) {
    return throwError(
      () => new HttpErrorResponse({ error: 'Internet is required.' })
    );
  }

  const token = authService.getToken();
  if (!token) {
    return next(req);
  }

  return next(
    req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    })
  );
};
